import { createContext } from 'common/ui/util';
import type { CreateContextReturn } from 'common/ui/util';

/**
 * Share the rendered EditorWrapper element with gutter-adjacent UI.
 *
 * Anchor gutter affordances to the wrapper through an explicit layout contract,
 * instead of walking up the DOM with selectors.
 */
const [
  EditorWrapperElementProvider,
  useEditorWrapperElement,
]: CreateContextReturn<HTMLElement | null> = createContext<HTMLElement | null>({
  name: 'editor-wrapper-element',
  strict: false,
  defaultValue: null,
});

export { EditorWrapperElementProvider, useEditorWrapperElement };
